// TODO: this will need to account for cases where two people are assinged to the same turf and repeat that dropoff step for them,
// b/c the backend calculations will work like that.

// necessary url params for building crewsheet are ?office=1&crewcanvassers=1|2|3

// THE door screen will need to do a call to both get the order of the turfs and then to get the driving directions.

import React, { Component } from "react";

import api from "../../store/api/api";
import { get as _get, lowerCase } from "lodash";
import "../../styles/crewSheet.scss";
import moment from "moment";
import { assignColorOnOrdinalScale } from "../../utils/colors";
import FullScreenSpinner from "../theme/loaders/FullScreenSpinner";
import BasicPointMap from "../maps/BasicPointMap";
import CrewSheetDrivingDirections from "../crewsheets/DrivingDirections";
import MapsLinks from "../crewsheets/MapsLinks";
import propTypes from "prop-types";
import { connect } from "react-redux";
import {withRouter} from "../../utils/withRouter";

const iconMap = [
  { iconName: "circle", iconSrc: "/icons/circle.png" },
  { iconName: "battery", iconSrc: "/icons/battery.png" },
  { iconName: "bell", iconSrc: "/icons/bell.png" },
  { iconName: "box", iconSrc: "/icons/box.png" },
  { iconName: "cloud", iconSrc: "/icons/cloud.png" },
  { iconName: "database", iconSrc: "/icons/database.png" },
  { iconName: "droplet", iconSrc: "/icons/droplet.png" },
  { iconName: "eye", iconSrc: "/icons/eye.png" },
];

class PageBreak extends Component {
  render = () => <div style={{ pageBreakAfter: "always" }} />;
}

class DoorCrewSheet extends Component {
  constructor(props) {
    super(props);

    this.state = {
      buffer_time: 10,
      time_in_office: 20,
    };
  }

  //A few things you can trust about the data: if there is a driver, it will always be last in the canvasser array.
  //CAnvassers also come sorted in the order that they should be dropped off.

  buildCanvasserRows() {
    let table_rows = this.props.crew.canvassers.map((canvasser) => {
      canvasser.assigned_roles = canvasser.assigned_roles.length
        ? canvasser.assigned_roles
        : canvasser.roles;
      return (
        <tr key={canvasser.id}>
          <td className="name">
            <b>
              {canvasser.firstname} {canvasser.lastname}
            </b>
            <div
              className={"color-tick"}
              style={{ backgroundColor: canvasser.color }}
            />{" "}
            <br />
            {canvasser.assigned_roles.map((d) => d.name).join(", ")} <br />*{" "}
            {canvasser.work_phone}
            <br />
            {canvasser.personal_phone}
            <br />
          </td>
          <td className="comments">{canvasser.comments}</td>

          <td className="info">
            <div className="empty-space">
              {canvasser.targethouseholds.length}
            </div>
          </td>
          <td className="info">
            <div className="empty-space"></div>
          </td>
          <td className="notes">
            <div className="empty-space"></div>
          </td>
        </tr>
      );
    });

    return table_rows;
  }

  getTimeGoals() {
    let { date, end_time, start_time } = this.props.crew.shift;
    //calculated time we leave so that canvassers can waste time and do things in the office
    let drop_off_buffer = this.state.buffer_time + this.state.time_in_office;

    let first_leg_time = _get(
      this.props.crew,
      "directions.legs[0].duration",
      600
    );
    first_leg_time = Math.round(first_leg_time / 60);

    let startMoment = new moment(`${date}T${start_time}`);
    let endMoment = new moment(`${date}T${end_time}`);

    if (!startMoment.isValid()) {
      startMoment = new moment().hour(9).minute(0).second(0);
    }

    if (!endMoment.isValid()) {
      endMoment = new moment().hour(17).minute(0).second(0);
    }

    // calcuate how long it takes everyone to get out of the office and to first site.
    let first_drop_off = startMoment
      .add(drop_off_buffer, "minutes")
      .add(first_leg_time, "minutes");
    let last_knock = endMoment
      .subtract(this.state.time_in_office, "minutes")
      .subtract(first_leg_time, "minutes");

    return { first_drop_off, last_knock };
  }

  renderMaps() {
    let canvassers = this.props.crew.canvassers;
    let all_points = [];
    let canvasserGroup = 0;
    let maps = canvassers.map((canvasser) => {
      let canvasser_points = canvasser.targethouseholds.map((d) => {
        return {
          ...d,
          lat: +d.latitude,
          lon: +d.longitude,
          color: canvasser.color,
          radius: null,
          group: canvasserGroup,
        };
      });
      canvasser.dropoff = canvasser.dropoff || {};
      // ADD THE DROPOFF POINT (always at the end, so it renders last and on top)
      canvasser_points.push({
        ...canvasser.dropoff,
        lat: +canvasser.dropoff.latitude,
        lon: +canvasser.dropoff.longitude,
        color: canvasser.color,
        radius: 10,
        is_dropoff: true,
        name: canvasser.initials.toUpperCase() + " DROP",
        group: canvasserGroup,
      });

      // add these points to all points map
      all_points = [...all_points, ...canvasser_points];
      canvasserGroup++;

      return (
        <>
          <div className={"crewsheet-individual-map"}>
            <h5>
              {canvasser.turf_name} -- {canvasser.targethouseholds.length} doors
              -- {canvasser.firstname} {canvasser.lastname}
            </h5>
            <BasicPointMap
              features={canvasser_points}
              target={"map-" + canvasser.canvasser_id} // name of div id to bind to
              requiredIcons={iconMap}
            />
          </div>
          <PageBreak />
        </>
      );
    });

    // crew wide map
    maps.unshift(
      <>
        <div className={"crewsheet-individual-map"}>
          <h5>Crew Map</h5>
          <BasicPointMap
            features={all_points}
            target={"crew-map-" + this.props.crew.id} // name of div id to bind to
            requiredIcons={iconMap}
          />
        </div>
        <PageBreak />
      </>
    );
    return maps;
  }

  render() {
    let { first_drop_off, last_knock } = this.getTimeGoals();
    let rows = this.buildCanvasserRows();

    let driver =
      this.props.crew.canvassers.find((d) =>
        [...d.assigned_roles, ...d.roles]
          .map((r) => lowerCase(r.type_name))
          .includes("driver")
      ) || {};
    let teamLeader =
      this.props.crew.canvassers.find((d) =>
        [...d.assigned_roles, ...d.roles]
          .map((r) => lowerCase(r.type_name))
          .includes("team leader")
      ) || {};

    return (
      <div className="crewsheet-container">
        <div className={"flx space_between crewsheet-header"}>
          <span>Crew {this.props.crew.id}</span>
          <span>{this.props.crew.canvassers[0].date}</span>
        </div>
        <div>
          <table className="crew-goal invisible-row">
            People
            <tbody>
              <tr>
                <td style={{ backgroundColor: "#c2c3c4" }}>Team Leader</td>
                <td>Driver</td>
              </tr>
              <tr>
                <td>
                  <b>
                    {teamLeader.firstname} {teamLeader.lastname}
                  </b>
                </td>
                <td>
                  {driver.firstname} {driver.lastname}
                </td>
              </tr>
            </tbody>
          </table>
          <table className="crew-goal space-table invisible-row">
            <thead>
              <tr>Crew Goal</tr>
            </thead>
            <tbody>
              <tr>
                <td>Goal</td>
                <td>Actual</td>
              </tr>
              <tr>
                <td>
                  {this.props.crew.canvassers.reduce(
                    (r, d) => (r += d.targethouseholds.length),
                    0
                  )}
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
          <table className="crew-goal space-table">
            <thead>
              <tr>Driver Times</tr>
            </thead>
            <tbody>
              <tr>
                <td>Goal</td>
                <td>Actual</td>
                <td>In The Field Time</td>
              </tr>
              <tr>
                <td>{first_drop_off && first_drop_off.format("h:mma")}</td>
                <td></td>
                <td>First Drop Off</td>
              </tr>
              <tr>
                <td>{last_knock && last_knock.format("h:mma")}</td>
                <td></td>
                <td>Last Knock</td>
              </tr>
            </tbody>
          </table>
        </div>
        <table className="crewsheet">
          <thead>
            <tr>
              <th className="name">Name/Phones</th>
              <th className="comments">Comments</th>
              <th className="info">Doors</th>
              <th className="info">Knocked</th>
              <th className="notes">Notes</th>
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </table>
        <MapsLinks crew={this.props.crew} />

        {!this.props.sessionVars.hideDrivingDirections && (
          <CrewSheetDrivingDirections crew={this.props.crew} />
        )}
        <PageBreak />
        {this.renderMaps()}
      </div>
    );
  }
}

/*
 * DoorCrewSheetHoc (Higher Order Component) is responsible for retrieving data and making sure that the visual components have the data
 * they need before printing.
 *
 * */
class DoorCrewSheetHoc extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      error: false,
      data: null,
    };

    this.canvasser_match_attempts = 0;
  }

  componentDidMount() {
    const shift = _get(this.props, "params.shift", 0);
    const urlParams = new URL(document.location).searchParams;
    const crewsParams = new URLSearchParams();

    crewsParams.append("shift", shift);
    crewsParams.append("crews", urlParams.get("crews").split(","));

    const nocache = urlParams.get("nocache");
    if (nocache) crewsParams.append("nocache", nocache);

    api
      .get(`door-crewsheet/?${crewsParams.toString()}`)
      .then((res) => {
        console.log("res", res.data, shift);
        this.pullCrewsFromHashes({
          pullImmediately: res.data.ready,
          hashkeys: res.data.hashkeys,
        });
      })
      .catch(() => {
        this.setState({ error: true, loading: false });
      });
  }

  pullCrewsFromHashes = (config = { pullImmediately: false, hashkeys: [] }) => {
    const pullTimeout = 6000;
    const maxRetries = 20;
    let retryCount = 0;

    const pull = () =>
      api
        .post("/crewsheetbuild/", { hashkeys: config.hashkeys })
        .then((res) => {
          if (res.data.ready) {
            let crews = res.data.crews || [res.data];
            //assign colors, HACK: filtering points on the front, should be done on the back

            crews.forEach((c) => {
              (c.canvassers || []).forEach((d, i) => {
                let uniqueHouseholds = [];
                (d.targethouseholds || []).forEach((h) => {
                  if (!uniqueHouseholds.some((k) => k.id === h.id)) {
                    uniqueHouseholds.push(h);
                  }
                });
                d.color = assignColorOnOrdinalScale(i);
                d.targethouseholds = uniqueHouseholds;
              });
            });

            this.setState({ data: crews, crewLoadReady: true, loading: false });
            console.log(this.state.data, "timer");
          } else {
            retryCount++;
            if (retryCount >= maxRetries) {
              console.error(`Crew sheet build timed out after ${maxRetries} retries`);
              this.setState({ error: true, loading: false });
            } else {
              setTimeout(pull, pullTimeout);
            }
          }
        })
        .catch((e) => {
          console.log(e);
          this.setState({ error: true, loading: false });
        });

    setTimeout(pull, config.pullImmediately ? 0 : pullTimeout);
  };

  renderCrews() {
    return this.state.data.map((crew) => {
      if (_get(this.props, "sessionVars.excludedCrews", []).includes(crew.id)) {
        return null;
      }
      return (
        <div key={crew.id} className="crewsheet-crew-block">
          <DoorCrewSheet crew={crew} sessionVars={this.props.sessionVars} />
        </div>
      );
    });
  }

  render() {
    if (this.state.loading) {
      return <FullScreenSpinner />;
    } else if (this.state.error) {
      return (
        <div className={"full_screen_fixed__modal full_screen_fixed__wrapper"}>
          <p style={{ fontSize: "24px", color: "red" }}>
            There was an error building this crewsheet.
          </p>
        </div>
      );
    } else {
      return (
        <div id="crewsheet-wrapper">
          <div className={"no-print"}>
            <button
              className={"primary"}
              style={{
                fontSize: "1.4em",
                width: "30vw",
                margin: "1em",
                float: "right",
              }}
              onClick={window.print}
            >
              Print
            </button>
          </div>
          {this.renderCrews()}
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => ({
  sessionVars: state.session.vars,
});

export default connect(mapStateToProps)(withRouter(DoorCrewSheetHoc));

DoorCrewSheet.propTypes = {
  crew: propTypes.object.isRequired,
  sessionVars: propTypes.object.isRequired,
};

DoorCrewSheetHoc.propTypes = {
  sessionVars: propTypes.object.isRequired,
};
